import React from 'react';
import {ACTION_TYPES} from "../../../consts";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../../app/app-terms";
import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {StringToJsx} from "../../string-to-jsx";

export class PoweredByStripeProps extends BaseProps {
  controller: ModuleController;
  className: String;
  i18n: AppTerms;
  link: String;
  title: String;
}

export const PoweredByStrip = (props: PoweredByStripeProps) => {
  const title = props.title.addClassToSubString('powered-by-strip-link-container')
  props.controller.action(ACTION_TYPES.poweredByDisplay, {
    widgetType: props.controller.appSettings.widgetType,
    partner: props.controller.appSettings?.bootstrapSettings?.publisherId,
    screenResolution: props.controller.device.screenWidth,
    widgetId: props.controller.appSettings?.bootstrapSettings.widgetId
  });

  const onPoweredByClick = () => {
    props.controller.action(ACTION_TYPES.poweredByClick, {
      widgetType: props.controller.appSettings.widgetType,
      partner: props.controller.appSettings?.bootstrapSettings?.publisherId,
      screenResolution: props.controller.device.screenWidth,
      widgetId: props.controller.appSettings?.bootstrapSettings?.widgetId
    });
  };

  const anchorProps = {
    href: props.link,
    className: ['powered-by-strip-container', props.className].join(' '),
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: () => onPoweredByClick()
  };

  return (
    <a {...anchorProps}>
      <StringToJsx domString={title}/>
    </a>
  )
};
